import { render } from "./deduct.vue?vue&type=template&id=4dc028ea&scoped=true"
import script from "./deduct.vue?vue&type=script&lang=js"
export * from "./deduct.vue?vue&type=script&lang=js"

import "./deduct.vue?vue&type=style&index=0&id=4dc028ea&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc028ea"]])

export default __exports__